import React, { useEffect, useState } from "react";
import {
  cancelDeliveryV2,
  completeInvoiceV2,
  getDueInvoiceStats,
  getInvoices,
  placeCourierSteadfastBooking,
  sendOnDelivery,
} from "../api/api";
import {
  Button,
  Card,
  Popconfirm,
  Table,
  Tag,
  Typography,
  notification,
  Row,
  Col,
  Input,
} from "antd";
import Column from "antd/lib/table/Column";
import moment from "moment";
import Spinner from "../components/Spinner";
import { siteInfo } from "../utils/SiteInfo";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Lot from "../components/Lot";
import Status from "../components/Status";

const { Text } = Typography;
const { Search } = Input;

export default function DueInvoice() {
  const [data, setData] = useState(null);
  const [stats, setStats] = useState(null);
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState({ due: true });
  const [reload, setReload] = useState(5);
  const [loading, setLoading] = useState(null);

  useEffect(() => {
    window.scrollTo({ top: 0 });
    let mFilter = filter
      ? { ...filter, page: page, due: true }
      : { page: page, due: true };
    getInvoices((mData) => {
      setData(mData);
    }, mFilter);
    getDueInvoiceStats((sData) => {
      setStats(sData);
    }, filter);
  }, [page, filter, reload]);

  const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
      message: message,
      description: description,
    });
  };

  const afterPerform = (result, message) => {
    setLoading(false);
    if (result) {
      setReload(Math.random());
      openNotificationWithIcon("success", "Success", "updated successfully");
    } else {
      openNotificationWithIcon("error", "Failed", message || "update failed");
    }
  };

  const config = useSelector((state) => state.config.config);

  return (
    <div>
      {/* Stats Display Section */}
      <div
        className="flex mb05"
        style={{ gap: 10, flexWrap: "wrap", marginBottom: "0.75rem" }}
      >
        <Card
          size="small"
          bodyStyle={{ padding: "10px 14px" }}
          style={{ borderRadius: 6, minWidth: 170 }}
        >
          <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 6 }}>
            Total Due
          </div>
          <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
            <Tag color="cyan">{stats?.total?.count || 0}</Tag>
            <Tag color="blue">
              ৳{stats?.total?.due ? stats.total.due.toLocaleString() : 0}
            </Tag>
          </div>
        </Card>

        <Card
          size="small"
          bodyStyle={{ padding: "10px 14px" }}
          style={{ borderRadius: 6, minWidth: 170 }}
        >
          <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 6 }}>
            Office Due
          </div>
          <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
            <Tag color="magenta">{stats?.office?.count || 0}</Tag>
            <Tag color="purple">
              ৳{stats?.office?.due ? stats.office.due.toLocaleString() : 0}
            </Tag>
          </div>
        </Card>

        <Card
          size="small"
          bodyStyle={{ padding: "10px 14px" }}
          style={{ borderRadius: 6, minWidth: 170 }}
        >
          <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 6 }}>
            Steadfast Due
          </div>
          <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
            <Tag color="orange">{stats?.steadfast?.count || 0}</Tag>
            <Tag color="volcano">
              ৳
              {stats?.steadfast?.due ? stats.steadfast.due.toLocaleString() : 0}
            </Tag>
          </div>
        </Card>

        <Card
          size="small"
          bodyStyle={{ padding: "10px 14px" }}
          style={{ borderRadius: 6, minWidth: 170 }}
        >
          <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 6 }}>
            SkyX Due
          </div>
          <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
            <Tag color="blue">{stats?.skyx?.count || 0}</Tag>
            <Tag color="geekblue">
              ৳{stats?.skyx?.due ? stats.skyx.due.toLocaleString() : 0}
            </Tag>
          </div>
        </Card>
      </div>

      {/* Method Filter Buttons */}
      <div className="flex mb05">
        <Card
          bodyStyle={{ padding: "8px 20px" }}
          onClick={() => {
            setPage(1);
            let prev = filter ? { ...filter } : {};
            delete prev.method;
            setFilter(prev);
          }}
          style={{
            marginRight: 8,
            backgroundColor: !filter?.method ? siteInfo.navColor : "#fff",
            color: !filter?.method ? "#fff" : "#000",
            cursor: "pointer",
          }}
        >
          All
        </Card>
        <Card
          bodyStyle={{ padding: "8px 20px" }}
          onClick={() => {
            setPage(1);
            let prev = filter ? { ...filter } : {};
            prev.method = "office";
            setFilter(prev);
          }}
          style={{
            marginRight: 8,
            backgroundColor:
              filter?.method === "office" ? siteInfo.navColor : "#fff",
            color: filter?.method === "office" ? "#fff" : "#000",
            cursor: "pointer",
          }}
        >
          Office
        </Card>
        <Card
          bodyStyle={{ padding: "8px 20px" }}
          onClick={() => {
            setPage(1);
            let prev = filter ? { ...filter } : {};
            prev.method = "steadfast";
            setFilter(prev);
          }}
          style={{
            marginRight: 8,
            backgroundColor:
              filter?.method === "steadfast" ? siteInfo.navColor : "#fff",
            color: filter?.method === "steadfast" ? "#fff" : "#000",
            cursor: "pointer",
          }}
        >
          Steadfast
        </Card>
        <Card
          bodyStyle={{ padding: "8px 20px" }}
          onClick={() => {
            setPage(1);
            let prev = filter ? { ...filter } : {};
            prev.method = "skyx";
            setFilter(prev);
          }}
          style={{
            marginRight: 8,
            backgroundColor:
              filter?.method === "skyx" ? siteInfo.navColor : "#fff",
            color: filter?.method === "skyx" ? "#fff" : "#000",
            cursor: "pointer",
          }}
        >
          SkyX
        </Card>
      </div>

      <Card style={{ marginBottom: ".5rem" }} size="small">
        <Row gutter={[16, 16]}>
          <Col md={{ span: 8 }}>
            <Text style={{ fontSize: "16px" }}>Search By Customer Phone</Text>
            <Search
              placeholder="Customer Phone Number"
              onSearch={(value) => {
                setPage(1);
                if (value) {
                  let prev = filter ? { ...filter } : {};
                  prev.phone = value;
                  setFilter(prev);
                } else {
                  let prev = filter ? { ...filter } : {};
                  delete prev.phone;
                  setFilter(prev);
                }
              }}
              allowClear
              enterButton
              style={{
                width: "100%",
                marginTop: "0.5rem",
              }}
            />
          </Col>
          <Col md={{ span: 8 }}>
            <Text style={{ fontSize: "16px" }}>Booking ID</Text>
            <Search
              placeholder="Booking ID"
              onSearch={(value) => {
                setPage(1);
                if (value) {
                  let prev = filter ? { ...filter } : {};
                  prev.booking = value;
                  setFilter(prev);
                } else {
                  let prev = filter ? { ...filter } : {};
                  delete prev.booking;
                  setFilter(prev);
                }
              }}
              allowClear
              enterButton
              style={{
                width: "100%",
                marginTop: "0.5rem",
              }}
            />
          </Col>
        </Row>
      </Card>

      {data ? (
        <Table
          className="smallFont"
          dataSource={data?.docs}
          rowKey={(record) => record._id}
          pagination={{
            current: page,
            pageSize: data?.limit,
            total: data?.totalDocs,
            showSizeChanger: false,
          }}
          onChange={(page, pageSize) => {
            setPage(page.current);
          }}
          bordered
        >
          <Column
            title="Serial"
            key="serial"
            align="center"
            render={(text, record, index) => <Text>{(page - 1) * (data?.limit || 10) + index + 1}</Text>}
          />
          <Column
            title="Invoice"
            key="invoice"
            align="center"
            render={(text, record, index) => (
              <Text style={{ cursor: "pointer", textTransform: "capitalize" }}>
                {record.code}
              </Text>
            )}
          />
          <Column
            title="Date"
            key="date"
            render={(text, record, index) => (
              <div>
                <Text
                  style={{
                    cursor: "pointer",
                    textTransform: "capitalize",
                    whiteSpace: "nowrap",
                  }}
                >
                  {moment(new Date(record.createdAt)).format("DD MMM, YYYY")}
                </Text>
              </div>
            )}
          />
          <Column
            title="Customer"
            key="customer_name"
            align="center"
            render={(text, record, index) => (
              <div>
                <p>{record.customer ? record.customer.name : "-"}</p>
                <span>{record.customer?.phone}</span>
              </div>
            )}
          />
          <Column
            title="Bookings"
            key="orders"
            align="center"
            render={(text, record, index) => (
              <div>
                {record.bookings
                  ? record.bookings?.map((p, k) => (
                      <a
                        href={`/booking/${p._id}`}
                        key={p._id}
                        rel="noreferrer"
                        target="_blank"
                      >
                        <Tag color="magenta" style={{ marginBottom: "0.5rem" }}>
                          {p._id}
                        </Tag>
                      </a>
                    ))
                  : "-"}
              </div>
            )}
          />
          <Column
            title="Amount"
            key="amount"
            align="center"
            render={(text, record, index) => <div>৳{record.amount}</div>}
          />
          <Column
            title="Paid"
            key="paid"
            align="center"
            render={(text, record, index) => <div>৳{record.paid}</div>}
          />
          <Column
            title="Due"
            key="due"
            align="center"
            render={(text, record, index) => <div>৳{record.due}</div>}
          />
          <Column
            title="Method"
            key="method"
            align="center"
            render={(text, record, index) => (
              <div>
                <Status name={record.method} />
              </div>
            )}
          />
          <Column
            title="Status"
            key="status"
            align="center"
            render={(text, record) => (
              <div>
                <Status
                  name={
                    config?.delivery_statuses?.find(
                      (s) => s.value === record.status,
                    )?.name || record.status
                  }
                />
              </div>
            )}
          />
          <Column
            title="Tracking"
            key="tracking"
            align="center"
            render={(text, record, index) => (
              <div>
                {record.courier?.tracking && (
                  <a
                    href={`https://steadfast.com.bd/t/${record.courier?.tracking}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Tag color="magenta">{record.courier?.tracking}</Tag>
                  </a>
                )}
              </div>
            )}
          />
          <Column
            title="Lot"
            key="lot"
            align="center"
            render={(text, record) => <Lot lot={record.lot} />}
          />
          <Column
            className="noPrint"
            title="Action"
            key="action"
            align="center"
            render={(text, record) => (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.5rem",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Link to={`/cash-counter/invoice/${record._id}`}>
                  <Button type="primary" style={{ width: "140px" }}>
                    Cash Counter
                  </Button>
                </Link>

                {/* <Link to={`/invoice/${record._id}`}>
                  <Button
                    type="ghost"
                    style={{
                      width: "140px",
                      backgroundColor: "#4F709C",
                      color: "#fff",
                    }}
                  >
                    Invoice
                  </Button>
                </Link> */}
              </div>
            )}
          />
        </Table>
      ) : (
        <Spinner />
      )}
    </div>
  );
}
